export default __webpack_public_path__ + "static/media/person.ce441c10.svg";